"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateModel = exports.getModelJsonById = exports.deployModel = exports.deleteModelById = exports.addModel = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加模型
 * @param config
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addModel = exports.addModel = function addModel(modelPO) {
  return _api.default.request({
    url: '/flow/model/create',
    method: 'post',
    data: modelPO
  });
};

/**
 * 修改模型
 * @param modelPO
 * @returns {AxiosPromise}
 */
var updateModel = exports.updateModel = function updateModel(modelPO) {
  return _api.default.request({
    url: '/flow/model/update',
    method: 'post',
    data: modelPO
  });
};

/**
 * 部署模型
 * @param config
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deployModel = exports.deployModel = function deployModel(modelId) {
  return _api.default.request({
    url: '/flow/model/deploy',
    method: 'post',
    params: {
      modelId: modelId
    }
  });
};

/**
 * 删除模型
 * @param modelId
 * @returns {AxiosPromise}
 */
var deleteModelById = exports.deleteModelById = function deleteModelById(modelId) {
  return _api.default.request({
    url: '/flow/model/delete',
    method: 'post',
    params: {
      modelId: modelId
    }
  });
};

/**
 * 根据modelId获取json
 * @param modelId
 * @returns {*}
 */
var getModelJsonById = exports.getModelJsonById = function getModelJsonById(modelId) {
  return _api.default.request({
    url: '/flow/model/getModelJsonById',
    params: {
      modelId: modelId
    }
  });
};